import { Box } from "@mui/material";
import { useTranslation } from "../../localization/useTranslation";
import { LegalEntityDocumentUpdateModel, SelectableDocumentTypeItem } from "./LegalEntityDocumentTab.types";
import { DotLegalCheckbox } from "@dotlegal/dotlegal-ui-components";
import { exhaustiveGuard } from "../../common/utilities";
import React from "react";
import { DocumentTypeUsageType } from "../../masterData/documentType/documentTypes/DocumentTypes.types";

export interface IAttachDocumentToSharingsProps {
    documentTypes: Array<SelectableDocumentTypeItem>;
    document: LegalEntityDocumentUpdateModel | undefined;
    onChange: (documentUsageType: DocumentTypeUsageType) => void;
}

function AttachDocumentToSharings(props: IAttachDocumentToSharingsProps) {
    const { translateString } = useTranslation();

    function renderAddToSharingsCheckboxes() {
        let documentType = props.documentTypes?.find((x) => x.id === props.document?.documentTypeId);

        return (
            <React.Fragment>
                {documentType?.usages
                    .filter((x) => x !== DocumentTypeUsageType.Contracts && x !== DocumentTypeUsageType.AllTransfers)
                    .map((x) => renderSharingCheckbox(x))}
            </React.Fragment>
        );
    }

    const renderSharingCheckbox = (documentUsageType: DocumentTypeUsageType) => {
        return (
            <Box key={documentUsageType} marginTop={1} marginBottom={1}>
                <DotLegalCheckbox
                    label={getLabel(documentUsageType)}
                    checked={props.document?.addDocumentToSharings.includes(documentUsageType) ?? false}
                    onChange={() => props.onChange(documentUsageType)}
                />
            </Box>
        );
    };

    const getLabel = (documentUsageType: DocumentTypeUsageType) => {
        switch (documentUsageType) {
            case DocumentTypeUsageType.DataProcessorTransfer:
                return translateString("adddataProcessorAgreementOnDataProcessor");
            case DocumentTypeUsageType.Tia:
                return translateString("addTransferImpactAssessmentOnDataProcessor");
            case DocumentTypeUsageType.JointDataControllerTransfer:
                return translateString("addJointDataControllerAgreementOnJointDataControllers");
            case DocumentTypeUsageType.DisclosureTransfer:
                return translateString("addDisclosureAgreementOnDisclosures");
            case DocumentTypeUsageType.SourceTransfer:
                return translateString("addDisclosureAgreementOnSource");
        }
    };

    return <>{renderAddToSharingsCheckboxes()}</>;
}

export default AttachDocumentToSharings;
